export default __webpack_public_path__ + "static/media/CV4.88b63193.png";